import type { DadosCnpj } from '@crm/contracts';
import { useCallback, useRef, useState } from 'react';
import { api, mensagemErro } from './api';

export interface ResultadoCnpj {
  dados: DadosCnpj;
  cache: boolean;
  desatualizado: boolean;
}

type Estado =
  | { status: 'idle' }
  | { status: 'carregando'; cnpj: string }
  | { status: 'ok'; cnpj: string; resultado: ResultadoCnpj }
  | { status: 'erro'; cnpj: string; erro: string };

/** Consulta GET /cnpj/:cnpj. Ignora respostas fora de ordem (usuário digitou outro CNPJ no meio). */
export function useConsultaCnpj() {
  const [estado, setEstado] = useState<Estado>({ status: 'idle' });
  const seq = useRef(0);

  const consultar = useCallback(async (cnpj: string): Promise<ResultadoCnpj | null> => {
    const n = ++seq.current;
    setEstado({ status: 'carregando', cnpj });
    try {
      const r = await api<ResultadoCnpj>(`/cnpj/${cnpj}`);
      if (n === seq.current) setEstado({ status: 'ok', cnpj, resultado: r });
      return n === seq.current ? r : null;
    } catch (e) {
      if (n === seq.current) setEstado({ status: 'erro', cnpj, erro: mensagemErro(e) });
      return null;
    }
  }, []);

  const limpar = useCallback(() => {
    seq.current++;
    setEstado({ status: 'idle' });
  }, []);

  return { estado, consultar, limpar };
}

export const SITUACAO_COR: Record<string, string> = {
  ATIVA: 'green', SUSPENSA: 'amber', INAPTA: 'amber', BAIXADA: 'red', NULA: 'red', DESCONHECIDA: '',
};
